export default __webpack_public_path__ + "875d699ca76cfe6b91728934fafcf7ae.otf";